import axios from 'axios';

export default {
    state: {
        productData: {},
        offers: [],
        reviews: {},
        offerSelect: '',
        images: {},
        offerCart: []
    },
    mutations: {
        setProductData(state, product) {
            state.productData = product
        },
        setOffers(state, offers) {
            state.offers = offers
        },
        setReviews(state, reviews) {
            state.reviews = reviews
        },
        setOfferSelect(state, offer) {
            state.offerSelect = offer
        },
        setOfferCart(state, offers) {
            state.offerCart = offers
        },
    },
    actions: {
        async getProductData({commit}) {
            let metaVuex = document.querySelector('meta[name="vuex"]');
            let product_id = metaVuex.getAttribute('value');
            /*commit('setProductData', JSON.parse(product));*/
            try {
                const product = await axios
                    .post('/darkrogua/babylon/api/Product@getProduct', {product_id})
                    .then(response => (response.data));
                commit('setProductData', product);
            } catch (e) {
                commit('setError', e);
                throw e
            }
        },
        async getOffers({commit}, product_id) {
            try {
                const offers = await axios
                    .post('/darkrogua/babylon/api/Product@getProductOffers', {product_id})
                    .then(response => (response.data));
                commit('setOffers', offers);
            } catch (e) {
                commit('setError', e);
                throw e
            }
        },
        async getReviews({commit}, product_id) {
            try {
                const reviews = await axios
                    .post('/darkrogua/babylon/api/Product@getReviews', {product_id})
                    .then(response => (response.data));
                commit('setReviews', reviews);
            } catch (e) {
                commit('setError', e);
                throw e
            }
        },
        async getOfferCart({commit}) {
            try {
                const offers = await axios
                    .post('/darkrogua/babylon/api/Product@getOfferCart')
                    .then(response => (response.data));
                commit('setOfferCart', offers);
            } catch (e) {
                commit('setError', e);
                throw e
            }
        }
    },
    getters: {
        productData: s => s.productData,
        offers: s => s.offers,
        reviews: s => s.reviews,
        offerSelect: s => s.offerSelect,
        offerCart: s => s.offerCart,
    }
}
